import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCurrency } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import '../ConciergeEvent/conciergeEvent.css'
import Toggle from 'react-toggle'
class ConciergeEventAdd extends React.Component {
  state = {
    type: '',
    slot_id: '',
    selected_slot: '',
    typeList: [],
    available_timeslots: [],
    event_id: '',
    type_id: '',
    company_id: '',
    categoryList: [],
    eventList: [],
    companyList: [],
    category_id: '',
    slots: [],
    date: moment().format('YYYY-MM-DD'),
    phone: '',
    email: '',
    coupon: '',
    country_code: '',
    bookingData: {},
    calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
    select_destination: {},
    calendarDateCellStatus: {},
    isLoading: false,
    initialLoading: false,
    event_search: '',
    type_title: '',
    calendarData: [],
    startingTimeSlot: 0,
    timeSlotDrop: 0,
    popupOpen: false,
    cruiseDetails: {},
    facilities: [],
    filterOpen: false,
    number_of_guests: 0,
    filterCount: 0,
    addOnPopUp: 0,
    appOnData: {},
    cost_of_service: 0,
    isCustomerOptional: false,
    isCouponApplied: false,
    childTicketCount: 0,
    adultTicketCount: 1,
    childTicketPrice: 0,
    adultTicketPrice: 0,
    minTicketCount: 0,
    maxTicketCount: 0,
    totalTickets: 1,
    coupon_id: '',
    enable_b2b_prices: false,
  }

  customStyle = {
    listBox: {
      padding: 10,
      borderRadius: 10,
      border: '1px solid #eee',
      backgroundColor: '#fefefe',
      textAlign: 'center',
    },
    listBoxSelected: {
      border: '1px solid #555',
    },
    listBoxImage: {
      height: 80,
      width: 80,
    },
    listBoxLabel: {
      color: '#00547e',
      fontWeight: '600',
      fontSize: '15px',
      padding: '5px 0',
      textTransform: 'uppercase',
      margin: 0,
    },
  }

  componentDidMount() {
    if (localStorage['user_role'] == 'concierge') {
      this.setState({ enable_b2b_prices: true })
    }
    this.getCategoryMaster()
    this.setState({ initialLoading: true })
    setTimeout(() => {
      this.setState({ initialLoading: false })
    }, 3000)
    this.calendarDateColor = this.calendarDateColor.bind(this)
    this.calendarCell = this.calendarCell.bind(this)
  }

  handleChange = (event) => {
    event.persist()

    if (event?.target?.name === 'cost_of_service') {
      if (event?.target?.value > -1) {
        this.setState({ [event?.target?.name]: event?.target?.value })
      }
    } else {
      this.setState({ [event?.target?.name]: event?.target?.value }, () => {
        if (event?.target?.name === 'category_id') {
          this.getCategoryList(event.target.value)
        }
        if (event?.target?.name === 'cruise_search') {
          this.getCategoryList(this.state.category_id, event.target.value)
        }
        if (event.target.name == 'enable_b2b_prices') {
          this.setState(
            {
              enable_b2b_prices: event.target.checked,
            },
            () => {
              this.clearData()
              this.getCategoryMaster()
            }
          )
        }
      })
    }
  }

  onBooking = async () => {
    if (!this.state.event_id) {
      Swal.fire('Please select Event!', '', 'error')
      return
    }
    if (!this.state.date) {
      Swal.fire('Please select Date!', '', 'error')
      return
    }
    if (!this.state.slot_id) {
      Swal.fire('Please select starting time!', '', 'error')
      return
    }

    if (!this.state.country_code && !this.state.isCustomerOptional) {
      Swal.fire('Country code required!', '', 'error')
      return
    }
    if (!this.state.phone && !this.state.isCustomerOptional) {
      Swal.fire('Contact Number required!', '', 'error')
      return
    }

    const data = {
      phone: this.state.phone,
      email: this.state.email,
      country_code: this.state.country_code,
      event_id: this.state.event_id,
      slot_id: this.state.slot_id,
      ticket_count: this.state.adultTicketCount,
      child_ticket_count: this.state.childTicketCount,
      coupon_id: this.state.coupon_id,
      cost_of_service: this.state.cost_of_service,
      isB2B: this.state.enable_b2b_prices,
    }

    this.setState({ isData: true, isLoading: true })

    await axios
      .post(Constant.getAPI() + '/booking/admin-event-book', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState(
            {
              bookingData: res.data.data,
            },
            () => {
              this.paymentPopUp()
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isData: false,
          isLoading: false,
        })
      })
  }

  getCategoryMaster = () => {
    this.setState({ isLoading: true, totalTickets: 1 })
    axios
      .get(Constant.getAPI() + '/cruise/list-cruise-masters', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          let categoryListCopy = res.data.data.filter(
            (category) =>
              category.is_active === true && (category.category_type == 'ACTIVITY' || category.category_type == 'EVENT')
          )
          this.setState(
            {
              typeList: categoryListCopy,
              type_id: categoryListCopy?.[0]?.id || '',
              type_title: categoryListCopy?.[0]?.cruise_cat_en || '',
              type: categoryListCopy?.[0]?.category_type || '',
            },
            () => {
              if (categoryListCopy?.length > 0 && categoryListCopy?.[0]?.id) {
                this.getCategoryList(categoryListCopy[0].id)
              } else {
                this.setState({ isLoading: false })
                if (categoryListCopy?.length === 0) {
                  Swal.fire({
                    title: 'No active event types available',
                    icon: 'info',
                    text: 'Please add active event types first.',
                    confirmButtonText: 'Ok',
                  })
                }
              }
            }
          )
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  getCategoryList = (category_id, keyword = '') => {
    this.setState(
      {
        category_id: category_id,
        isLoading: true,
        categoryList: [],
        companyList: [],
        eventList: [],
        available_timeslots: [],
        company_id: '',
        event_id: '',
        totalTickets: 1,
      },
      () => {
        const catType = this.state.typeList?.find((ele) => ele.id == category_id)?.category_type
        axios
          .get(Constant.getAPI() + `/event-categories/categories/${catType}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
            params: {
              keyword: keyword,
            },
          })
          .then((res) => {
            if (res.data.success) {
              const filterdCategories = res.data.data?.filter((ele) => ele.is_active == true)
              console.log('Filtered Categories:', filterdCategories)

              this.setState(
                {
                  categoryList: filterdCategories,
                  category_id: filterdCategories?.length ? filterdCategories?.[0]?.id : '',
                },
                () => {
                  if (filterdCategories?.length > 0 && filterdCategories?.[0].id) {
                    this.getCompanyList(filterdCategories?.[0].id, catType)
                  } else {
                    this.setState({ isLoading: false })
                    if (filterdCategories?.length === 0) {
                      Swal.fire({
                        title: 'No categories available',
                        icon: 'info',
                        text: 'No active categories found for this event type.',
                        confirmButtonText: 'Ok',
                      })
                    }
                  }
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoading: false,
            })
          })
      }
    )
  }

  getCompanyList = (category_id, type, keyword = '') => {
    this.setState(
      {
        isLoading: true,
        companyList: [],
        eventList: [],
        available_timeslots: [],
        event_id: '',
        totalTickets: 1,
      },
      () => {
        axios
          .get(Constant.getAPI() + `/event-companies/event-companies-v2/${type}/${category_id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
            params: {
              keyword: keyword,
            },
          })
          .then((res) => {
            if (res.data.success) {
              const filteredCompanies = res.data.data?.filter((ele) => ele.is_active == true)
              this.setState(
                {
                  companyList: filteredCompanies,
                  company_id: filteredCompanies?.length ? filteredCompanies?.[0].id : '',
                },
                () => {
                  if (filteredCompanies?.length > 0 && filteredCompanies?.[0]?.id) {
                    this.getEventList(filteredCompanies?.[0].id, category_id, type)
                  } else {
                    this.setState({ isLoading: false })
                    if (filteredCompanies?.length === 0) {
                      Swal.fire({
                        title: 'No companies available',
                        icon: 'info',
                        text: 'No active companies found for this category.',
                        confirmButtonText: 'Ok',
                      })
                    }
                  }
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoading: false,
            })
          })
      }
    )
  }

  getEventList = (company_id, category_id, type, keyword = '') => {
    this.setState(
      {
        category_id: category_id,
        isLoading: true,
        eventList: [],
        available_timeslots: [],
        totalTickets: 1,
      },
      () => {
        axios
          .get(Constant.getAPI() + `/event/list-company-events-v2/${type}/${company_id}/${category_id}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
            params: {
              keyword: keyword,
            },
          })
          .then((res) => {
            if (res.data.success) {
              this.setState(
                {
                  eventList: res.data.data,
                  event_id: res.data.data?.length ? res.data.data?.[0].id : '',
                },
                () => {
                  if (res.data.data?.length > 0 && res.data.data?.[0].id) {
                    this.getCalendarData()
                    this.getEventDetails()
                  } else {
                    this.setState({ isLoading: false })
                    if (res.data.data?.length === 0) {
                      Swal.fire({
                        title: 'No events available',
                        icon: 'info',
                        text: 'No events found for this company.',
                        confirmButtonText: 'Ok',
                      })
                    }
                  }
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoading: false,
            })
          })
      }
    )
  }

  selectSlot = (id) => {
    const slotData = this.state.available_timeslots?.find((ele) => ele.id === id)
    if (slotData) {
      this.setState({
        slot_id: id,
        totalTickets: slotData.ticket_count > 0 ? slotData.ticket_count : 1,
        selected_slot: `${moment(slotData.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(slotData.end_time, 'HH:mm:ss').format('hh:mm A')}`,
      })
    }
  }

  getCalendarData = () => {
    this.setState(
      {
        available_timeslots: [],
        isLoading: true,
        totalTickets: 1,
      },
      () => {
        const data = {
          date: moment(this.state.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
          event_id: this.state.event_id,
        }
        axios
          .post(Constant.getAPI() + '/event/monthly-calendar', data, {
            headers: {
              'Allow-Control-Allow-Origin': '*',
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          })
          .then(async (res) => {
            if (res.data.success) {
              const slotList = res.data?.data || []
              let dateSlotObj = {}
              for (let item of slotList) {
                dateSlotObj['date-' + parseInt(moment(item.event_date).format('DD'))] = {
                  enable: true,
                }
              }

              this.setState(
                {
                  slots: slotList,
                  calendarDateCellStatus: dateSlotObj,
                  calendarData: res.data?.data,
                },
                () => {
                  this.calendarDateSeleted(parseInt(moment(slotList?.[0]?.event_date, 'YYYY-MM-DD').format('DD')))
                }
              )
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
          .finally(() => {
            this.setState({
              isLoading: false,
            })
          })
      }
    )
  }

  getEventDetails = () => {
    this.setState(
      {
        adultTicketCount: 1,
        adultTicketPrice: 0,
        childTicketCount: 0,
        childTicketPrice: 0,
        minTicketCount: 0,
        maxTicketCount: 0,
        isLoading: true,
      },
      () => {
        if (this.state.event_id) {
          axios
            .get(
              Constant.getAPI() + `/event/event-details/${this.state.event_id}?isB2B=${this.state.enable_b2b_prices}`,
              {
                headers: {
                  'Allow-Control-Allow-Origin': '*',
                  Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                  country_short_name: `${localStorage.getItem('countryShortName')}`,
                },
              }
            )
            .then(async (res) => {
              if (res.data.success) {
                const evtData = res.data.data
                this.setState({
                  adultTicketPrice: evtData.amount,
                  childTicketPrice: evtData.child_amount,
                  minTicketCount: evtData.min_tickets,
                  maxTicketCount: evtData.max_tickets,
                })
              }
            })
            .catch((err) => {
              if (err?.response?.status === 401) {
                Constant.getAuthLogout()
              } else {
                Swal.fire({
                  title: err?.response?.data?.data?.details?.[0]?.message || err?.message,
                  icon: 'error',
                  text: '',
                  type: 'error',
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Ok',
                })
              }
            })
            .finally(() => {
              this.setState({
                isLoading: false,
              })
            })
        } else {
          this.setState({
            isLoading: false,
          })
        }
      }
    )
  }

  processPayment = async () => {
    this.setState({ isLoading: false })
    const body = {
      user_id: this.state.bookingData?.user_id,
      event_id: this.state.bookingData?.event_id,
      slot_id: this.state.bookingData?.slot_id,
      DisplayCurrencyIso: this.state.bookingData?.currency,
      ticket_count: this.state.adultTicketCount,
      child_ticket_count: this.state.childTicketCount,
      coupon_id: this.state.bookingData?.coupon_id,
      cost_of_service: this.state.bookingData?.cost_of_service,
      isB2B: this.state.enable_b2b_prices,
    }
    await axios
      .post(Constant.getAPI() + '/booking/process-event-payment', body, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          Swal.fire({
            title: 'Booking Success',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Booking Details',
          }).then(() => {
            window.location.href = `#/new-evt/${res?.data?.data?.booking_id}`
          })
          this.clearData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  paymentPopUp = () => {
    Swal.fire({
      width: '700px',
      title: '<div>Payment Confirmation</div>',
      html: `
        <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td style="text-align: left">${this.state.bookingData?.event_name || '--'}</td></tr>
            <tr>
              <th>Date</th>
              <td style="text-align: left">${this.state.bookingData?.event_date || '--'}</td></tr>
            <tr>
              <th>Slot</th>
              <td style="text-align: left">${this.state.bookingData?.start_time || '--'} - ${this.state.bookingData?.end_time || '--'}</td></tr>
            <tr>
              <th>Event Amount</th>
              <td style="text-align: left">${this.state.bookingData?.event_amount ? this.state.bookingData?.event_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td>
            </tr>
            <tr>
              <th>Cost Of Service</th>
              <td style="text-align: left">${this.state.bookingData?.cost_of_service ? this.state.bookingData?.cost_of_service + ' ' + getCurrency(localStorage.getItem('countryShortName')) : '--'}</td>
            </tr>
              <th>Coupon Applied Amount</th>
              <td style="text-align: left">${this.state.bookingData?.coupon_applied_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) || '--'}</td></tr>
            <tr>
              <th>VAT</th>
              <td style="text-align: left">${this.state.bookingData?.vat + ' ' + getCurrency(localStorage.getItem('countryShortName')) || '--'}</td>
            </tr>
            <tr>
              <th>Total Booking Amount</th>
              <td style="text-align: left">${this.state.bookingData?.total_booking_amount + ' ' + getCurrency(localStorage.getItem('countryShortName')) || '--'}</td></tr>
            <tr>
          </tbody>
        </table>
      `,
      confirmButtonText: 'Process Payment',
      denyButtonText: `Cancel`,
      // showDenyButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.processPayment()
      }
    })
  }

  calendarMonthChanger = async (value) => {
    let date =
      moment().startOf('M').format('YYYY-MM-DD') ==
        moment(new Date(this.state.calendarDate))
          .add('M', value ? 1 : -1)
          .format('YYYY-MM-DD')
        ? moment().format('YYYY-MM-DD')
        : moment(this.state.calendarDate)
          .add('M', value ? 1 : -1)
          .format('YYYY-MM-DD')
    this.setState(
      {
        calendarDate: moment(this.state.calendarDate)
          .add('M', value ? 1 : -1)
          .format('YYYY-MM-DD'),
        date: date,
      },
      () => {
        this.getCalendarData()
        // this.calendarDateSeleted(parseInt(moment(date).format('DD')), 1)
      }
    )
  }

  calendarDateSeleted = async (value) => {
    let date = moment(new Date(this.state.calendarDate)).date(value).format('YYYY-MM-DD')
    if (date) {
      if (moment(new Date(date)) < moment().subtract(1, 'd') || this.calendarCell(value, 'E')) {
        return
      }
      const slotsData = this.state.slots.find((ele) => ele.event_date === date)
      this.setState(
        {
          available_timeslots: slotsData?.available_timeslots,
          selected_slot: `${moment(slotsData?.available_timeslots?.[0]?.start_time, 'HH:mm:ss').format('hh:mm A')} - ${moment(slotsData?.available_timeslots?.[0]?.end_time, 'HH:mm:ss').format('hh:mm A')}`,
          slot_id: slotsData?.available_timeslots?.[0]?.id,
          date: date,
          totalTickets: slotsData?.available_timeslots?.[0]?.ticket_count || 1,
        },
        () => {
          // this.getCalendarData()
          this.calendarDateColor(value)
        }
      )
    }
  }

  calendarDateColor(value) {
    let date = moment(new Date(this.state.calendarDate)).date(value).format('YYYY-MM-DD')
    if (date == this.state.date && this.state.slots.length > 0) {
      return 'select-blue'
    } else if (moment(new Date(date)) < moment().subtract(1, 'd')) {
      return 'month-date'
    } else {
      const availableDate = this.state.slots?.find((ele) => ele.event_date == date && ele.available == true)
      if (!availableDate) {
        return 'month-date'
      }
      return 'light-blue'
    }
  }

  calendarCell(value, type) {
    if (this.state.calendarDateCellStatus['date-' + value]) {
      if (this.state.calendarDateCellStatus['date-' + value].price && type == 'P') {
        return (
          this.state.calendarDateCellStatus['date-' + value].price +
          ` ${getCurrency(localStorage.getItem('countryShortName'))}`
        )
      }
      if (type == 'E') {
        if (!this.state.calendarDateCellStatus['date-' + value].enable) {
          return true
        }
      }
    }
  }

  clearData = () => {
    this.setState({
      slot_id: '',
      selected_slot: '',
      available_timeslots: [],
      event_id: '',
      type_id: '',
      company_id: '',
      categoryList: [],
      eventList: [],
      companyList: [],
      category_id: '',
      slots: [],
      date: moment().format('YYYY-MM-DD'),
      phone: '',
      email: '',
      coupon: '',
      country_code: '',
      bookingData: {},
      calendarDate: moment().startOf('month').format('YYYY-MM-DD'),
      select_destination: {},
      calendarDateCellStatus: {},
      isLoading: false,
      initialLoading: false,
      event_search: '',
      type_title: '',
      calendarData: [],
      startingTimeSlot: 0,
      timeSlotDrop: 0,
      popupOpen: false,
      cruiseDetails: {},
      facilities: [],
      filterOpen: false,
      number_of_guests: 0,
      filterCount: 0,
      addOnPopUp: 0,
      appOnData: {},
      cost_of_service: 0,
      isCustomerOptional: false,
      isCouponApplied: false,
      childTicketCount: 0,
      adultTicketCount: 1,
      childTicketPrice: 0,
      adultTicketPrice: 0,
      minTicketCount: 0,
      maxTicketCount: 0,
      totalTickets: 1,
      coupon_id: '',
    })
  }

  validateCouponCode = () => {
    if (!this.state.coupon) {
      Swal.fire('Coupon code required!', '', 'error')
      return
    }
    this.setState({ isLoading: true, isCustomerOptional: false, coupon_id: '' })

    const data = {
      cruise_id: this.state.event_id,
      booking_date: moment(this.state.date, 'YYYY-MM-DD').format('YYYY/MM/DD'),
      coupon: this.state.coupon,
    }
    axios
      .post(Constant.getAPI() + `/booking/verify-coupon`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const resp = res.data.data
          if (resp.amount_type == 'PERCENTAGE' && resp.coupon_amount == 100) {
            this.setState({
              isCustomerOptional: true,
            })
          }
          this.setState({
            isCouponApplied: true,
            coupon_id: resp.id,
          })
          Swal.fire(res.data.message, '', 'success')
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  removeCouponCode = () => {
    this.setState({ coupon: '', isCouponApplied: false, isCustomerOptional: false, coupon_id: '' })
  }

  // Function to increment count
  incrementAdultTicket = () => {
    if (
      this.state.maxTicketCount < this.state.adultTicketCount + this.state.childTicketCount + 1 ||
      this.state.totalTickets < this.state.adultTicketCount + this.state.childTicketCount + 1
    ) {
      Swal.fire('You have reached maximum available tickets for this day!', '', 'error')
      return
    }
    this.setState((prevState) => ({
      adultTicketCount: prevState.adultTicketCount + 1,
    }))
  }

  incrementChildTicket = () => {
    if (
      this.state.maxTicketCount < this.state.adultTicketCount + this.state.childTicketCount + 1 ||
      this.state.totalTickets < this.state.adultTicketCount + this.state.childTicketCount + 1
    ) {
      Swal.fire('You have reached maximum available tickets for this day!', '', 'error')
      return
    }
    this.setState((prevState) => ({
      childTicketCount: prevState.childTicketCount + 1,
    }))
  }

  // Function to decrement count
  decrementAdultTicket = () => {
    if (this.state.minTicketCount > this.state.adultTicketCount - 1) {
      Swal.fire('You have reached minimum available tickets for this day!', '', 'error')
      return
    }
    if (this.state.adultTicketCount > 0) {
      this.setState((prevState) => ({
        adultTicketCount: prevState.adultTicketCount - 1,
      }))
    }
  }

  decrementChildTicket = () => {
    if (this.state.childTicketCount > 0) {
      this.setState((prevState) => ({
        childTicketCount: prevState.childTicketCount - 1,
      }))
    }
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    {(this.state.isLoading || this.state.initialLoading) && (
                      <div className="loader-overlay">
                        <div className="loader"></div>
                      </div>
                    )}

                    {/* Page Title with B2B Toggle */}
                    <div
                      style={{
                        marginBottom: 25,
                        paddingBottom: 15,
                        border: '2px solid #00547e',
                        padding: '10px 20px',
                        borderRadius: '10px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        alignContent: 'center',
                      }}
                    >
                      <h1
                        style={{
                          fontSize: '26px',
                          fontWeight: '700',
                          color: '#00547e',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                          margin: 0,
                        }}
                      >
                        <i
                          className="icofont icofont-calendar"
                          style={{ marginRight: '10px', fontSize: '28px' }}
                        ></i>
                        Event Booking
                      </h1>
                      {localStorage['user_role'] != 'concierge' && (
                        <div
                          style={{
                            display: 'flex',
                            width: '250px',
                            justifyContent: 'space-between',
                            alignContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <label style={{ width: '150px', fontWeight: '600', marginBottom: 0 }}>
                            Enable B2B Prices
                          </label>
                          <Toggle
                            className="w-25"
                            name="enable_b2b_prices"
                            id="enable_b2b_prices"
                            icons={false}
                            onChange={this.handleChange}
                            checked={this.state.enable_b2b_prices}
                          />
                        </div>
                      )}
                    </div>

                    <div className="">
                      <div className="">
                        <div className="">
                          <div className="card-padding mb-3">
                            <h2 className="text-heading">Select Type</h2>
                            <div className="category-data mt-3">
                              {this.state.typeList?.map((ele) => (
                                <div
                                  key={ele.id}
                                  style={{
                                    ...this.customStyle.listBox,
                                    ...(this.state.type_id == ele.id ? this.customStyle.listBoxSelected : {}),
                                  }}
                                  onClick={() => [
                                    this.getCategoryList(ele.id),
                                    this.setState({
                                      type_title: ele.cruise_cat_en,
                                      type_id: ele.id,
                                      type: ele.category_type,
                                    }),
                                  ]}
                                >
                                  <img
                                    src={
                                      ele.cruise_cat_img !== undefined && ele.cruise_cat_img !== null
                                        ? Constant.getImage() + ele.cruise_cat_img
                                        : './assets/images/no_image.png'
                                    }
                                    alt=""
                                    onError={({ currentTarget }) => {
                                      currentTarget.src = './assets/images/no_image.png'
                                    }}
                                    style={this.customStyle.listBoxImage}
                                  />
                                  <p style={this.customStyle.listBoxLabel}>{ele.cruise_cat_en}</p>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="card-padding mb-3">
                            <h2 className="text-heading">Select {this.state.type_title} Categories</h2>
                            <div className="category-data mt-3">
                              {this.state.categoryList.length > 0 ? (
                                <>
                                  {this.state.categoryList.map((cat) => (
                                    <div
                                      key={cat.id}
                                      style={{
                                        ...this.customStyle.listBox,
                                        ...(this.state.category_id == cat.id ? this.customStyle.listBoxSelected : {}),
                                      }}
                                      onClick={() => [
                                        this.getCompanyList(cat.id, cat.category_type),
                                        this.setState({ category_id: cat.id, totalTickets: 1 }),
                                      ]}
                                    >
                                      <img
                                        src={
                                          cat.category_img_url !== undefined && cat.category_img_url !== null
                                            ? Constant.getImage() + cat.category_img_url
                                            : './assets/images/no_image.png'
                                        }
                                        alt=""
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                        style={this.customStyle.listBoxImage}
                                      />
                                      <p style={this.customStyle.listBoxLabel}>{cat.category_name_en}</p>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="mt-3 no-data">
                                  <h5 className="">No Categories</h5>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* ------------------------------------------------------------------------------------- */}
                          <div className="card-padding mb-3">
                            <h2 className="text-heading">Companies</h2>
                            <div className="category-data mt-3">
                              {this.state.companyList.length > 0 ? (
                                <>
                                  {this.state.companyList.map((company) => (
                                    <div
                                      key={company.id}
                                      style={{
                                        ...this.customStyle.listBox,
                                        ...(this.state.company_id == company.id
                                          ? this.customStyle.listBoxSelected
                                          : {}),
                                      }}
                                      onClick={() => [
                                        this.getEventList(company.id, company.categoryId, this.state.type),
                                        this.setState({ company_id: company.id }),
                                      ]}
                                    >
                                      <img
                                        src={
                                          company.banner_img !== undefined && company.banner_img !== null
                                            ? Constant.getImage() + company.banner_img
                                            : './assets/images/no_image.png'
                                        }
                                        alt=""
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                        style={this.customStyle.listBoxImage}
                                      />
                                      <p style={this.customStyle.listBoxLabel}>
                                        {company.company_name ||
                                          company.company_name_en ||
                                          company.company_short_name_en ||
                                          company.company_short_name}
                                      </p>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="mt-3 no-data">
                                  <h5 className="">No Companies</h5>
                                </div>
                              )}
                            </div>
                          </div>
                          {/* ----------------------------------------------------------------------------------- */}
                          <div className="card-padding mb-3">
                            <h2 className="text-heading">{this.state.type_title}</h2>
                            <div className="category-data mt-3">
                              {this.state.eventList.length > 0 ? (
                                <>
                                  {this.state.eventList.map((evt) => (
                                    <div
                                      key={evt.id}
                                      style={{
                                        ...this.customStyle.listBox,
                                        ...(this.state.event_id == evt.id ? this.customStyle.listBoxSelected : {}),
                                      }}
                                      onClick={() => [
                                        this.setState({ event_id: evt.id }),
                                        this.getCalendarData(),
                                        this.getEventDetails(),
                                      ]}
                                    >
                                      <img
                                        src={
                                          evt.event_image !== undefined && evt.event_image !== null
                                            ? Constant.getImage() + evt.event_image
                                            : './assets/images/no_image.png'
                                        }
                                        alt=""
                                        onError={({ currentTarget }) => {
                                          currentTarget.src = './assets/images/no_image.png'
                                        }}
                                        style={this.customStyle.listBoxImage}
                                      />
                                      <p style={this.customStyle.listBoxLabel}>{evt.event_name}</p>
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="mt-3 no-data">
                                  <h5 className="">No {this.state.type_title}</h5>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {this.state.categoryList.length > 0 && (
                          <div className="mt-20">
                            <div className="booking-data">
                              <div>
                                <h2 className="text-heading">Booking</h2>
                                <div className="booking-box mt-3">
                                  <div className="month-cal">
                                    {moment(new Date(this.state.calendarDate)).format('MM-YYYY') >
                                      moment().startOf('M').format('MM-YYYY') ? (
                                      <div
                                        className=""
                                        onClick={() => this.calendarMonthChanger(0)}
                                      >
                                        <img
                                          src="./assets/icon/concierge/arrow-prev.svg"
                                          alt=""
                                        />
                                      </div>
                                    ) : (
                                      <div></div>
                                    )}
                                    <div className="day">
                                      {moment(new Date(this.state.calendarDate)).format('MMMM, YYYY')}
                                    </div>
                                    <div
                                      className=""
                                      onClick={() => this.calendarMonthChanger(1)}
                                    >
                                      <img
                                        src="./assets/icon/concierge/arrow-next.svg"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="day-list mt-3">
                                    <span className="day-all">SUN</span>
                                    <span className="day-all">MON</span>
                                    <span className="day-all">TUE</span>
                                    <span className="day-all">WED</span>
                                    <span className="day-all">THU</span>
                                    <span className="day-all">FRI</span>
                                    <span className="day-all">SAT</span>
                                  </div>
                                  <div className="mt-3 month-data">
                                    {Array.apply(null, Array(moment(new Date(this.state.calendarDate)).day())).map(
                                      (destination, i) => (
                                        <span key={i}></span>
                                      )
                                    )}
                                    {Array.apply(
                                      null,
                                      Array(moment(new Date(this.state.calendarDate)).daysInMonth())
                                    ).map((destination, i) => (
                                      <span
                                        className={this.calendarDateColor(i + 1) + ' month-date'}
                                        key={i}
                                        onClick={() => this.calendarDateSeleted(i + 1)}
                                      >
                                        <div>{i + 1}</div>
                                      </span>
                                    ))}
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div className="">
                                  <h2 className="text-heading">Starting Time</h2>

                                  {this.state.available_timeslots?.length > 0 ? (
                                    <div className="position-relative mt-3">
                                      <div
                                        id="accordion"
                                        role="tablist"
                                      >
                                        <div
                                          className="position-relative"
                                          onClick={() => this.setState({ timeSlotDrop: !this.state.timeSlotDrop })}
                                        >
                                          <div>
                                            <div className="collapsed card-shadow p-3 d-flex justify-content-between align-items-center rounded ">
                                              <div className="d-flex gap-10 align-items-center">
                                                <div className="location-icon">
                                                  <img
                                                    src="./assets/icon/concierge/location-new.svg"
                                                    alt=""
                                                  />
                                                </div>
                                                <div className="location-in">
                                                  <h3 className="m-0">{this.state.selected_slot}</h3>
                                                </div>
                                              </div>
                                              <div className="arrow">
                                                <img
                                                  src="./assets/icon/concierge/arrow-up.svg"
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          {this.state.timeSlotDrop ? (
                                            <div>
                                              <div className="destination p-3 card-shadow">
                                                {this.state.available_timeslots?.map((tm) => (
                                                  <div
                                                    key={tm.id}
                                                    className={
                                                      (tm.id == this.state.slot_id ? 'destination-select' : '') +
                                                      ' destination-data'
                                                    }
                                                    onClick={() => this.selectSlot(tm.id)}
                                                  >
                                                    <div className="d-flex justify-content-between align-items-center gap-10">
                                                      <div>
                                                        <h1 className="m-0">
                                                          {moment(tm.start_time, 'HH:mm:ss').format('hh:mm A')} -{' '}
                                                          {moment(tm.end_time, 'HH:mm:ss').format('hh:mm A')}
                                                        </h1>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mt-3 no-data">
                                      <h5 className="">No Slot available</h5>
                                    </div>
                                  )}
                                </div>
                                <div className="mt-3">
                                  <div style={{ display: 'flex' }}>
                                    <h2 className="text-heading">No Of Tickets</h2>
                                    <label
                                      className="col-form-label colformlabel"
                                      style={{ marginLeft: '60%' }}
                                    >
                                      {this.state.totalTickets -
                                        this.state.childTicketCount -
                                        this.state.adultTicketCount}{' '}
                                      Tickets left
                                    </label>
                                  </div>
                                  {this.state.available_timeslots?.length > 0 ? (
                                    <div className="mt-3">
                                      <div className="counter-container">
                                        <div className="counter-label">Adult</div>

                                        <div className="counter-buttons">
                                          <button
                                            className="counter-button decrement"
                                            onClick={this.decrementAdultTicket}
                                          >
                                            -
                                          </button>
                                          <div className="count">{this.state.adultTicketCount}</div>
                                          <button
                                            className="counter-button increment"
                                            onClick={this.incrementAdultTicket}
                                          >
                                            +
                                          </button>
                                        </div>

                                        <div className="priceE">
                                          {this.state.adultTicketPrice * this.state.adultTicketCount}{' '}
                                          {getCurrency(localStorage.getItem('countryShortName'))}
                                        </div>
                                      </div>
                                      <div className="counter-container mt-3">
                                        <div className="counter-label">Child</div>

                                        <div className="counter-buttons">
                                          <button
                                            className="counter-button decrement"
                                            onClick={this.decrementChildTicket}
                                          >
                                            -
                                          </button>
                                          <div className="count">{this.state.childTicketCount}</div>
                                          <button
                                            className="counter-button increment"
                                            onClick={this.incrementChildTicket}
                                          >
                                            +
                                          </button>
                                        </div>

                                        <div className="priceE">
                                          {this.state.childTicketPrice * this.state.childTicketCount}{' '}
                                          {getCurrency(localStorage.getItem('countryShortName'))}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="mt-3 no-data">
                                      <h5 className="">No Tickets Available</h5>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div></div>
                            </div>
                          </div>
                        )}
                        <div className="d-flex gap-20 mt-3">
                          <div className="w-100">
                            <div className="additionl-box">
                              <label className="col-form-label colformlabel w-100">Cost Of Service</label>
                              <input
                                type="number"
                                min={0}
                                className="form-control border-radius"
                                name="cost_of_service"
                                id="cost_of_service"
                                placeholder={`Cost Of Service`}
                                onChange={this.handleChange}
                                value={this.state.cost_of_service}
                              />
                            </div>
                          </div>
                          <div className="w-100">
                            <div className="additionl-box">
                              <label className="col-form-label colformlabel w-100">Coupon code</label>
                              <div
                                className="input-group d-flex"
                                style={{ marginBottom: '0', overflow: 'hidden' }}
                              >
                                <input
                                  type="text"
                                  className="form-control border-radius"
                                  name="coupon"
                                  id="coupon"
                                  placeholder="Coupon Code"
                                  onChange={this.handleChange}
                                  value={this.state.coupon}
                                  style={{ borderRight: '0' }}
                                  disabled={this.state.isCouponApplied}
                                />
                                {this.state.isCouponApplied ? (
                                  <button
                                    className="btn custom-apply-btn"
                                    onClick={this.removeCouponCode}
                                    type="button"
                                  >
                                    Remove
                                  </button>
                                ) : (
                                  <button
                                    className="btn custom-apply-btn"
                                    onClick={this.validateCouponCode}
                                    type="button"
                                    disabled={this.state.coupon.length == 0}
                                  >
                                    Apply
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="d-flex gap-20">
                          <div className="w-100 mt-3">
                            <div className="additionl-box">
                              <label className="col-form-label colformlabel w-100">
                                Customer Number {this.state.isCustomerOptional ? '(Optional)' : ''}
                              </label>
                              <div className="d-flex form-control contact-filed border-radius">
                                <input
                                  style={{ width: '30%' }}
                                  type="text"
                                  className="border-none input-border"
                                  name="country_code"
                                  id="country_code"
                                  placeholder={`Country`}
                                  onChange={this.handleChange}
                                  value={this.state.country_code}
                                />
                                <input
                                  type="text"
                                  className="form-control border-none"
                                  style={{ width: '70%' }}
                                  name="phone"
                                  id="phone"
                                  placeholder={`Contact Number`}
                                  onChange={this.handleChange}
                                  value={this.state.phone}
                                  maxLength={10}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="w-100 mt-3">
                            <div className="additionl-box">
                              <label className="col-form-label colformlabel w-100">Customer Email (Optional)</label>
                              <input
                                type="text"
                                className="form-control border-radius"
                                name="email"
                                id="email"
                                placeholder={`Customer Email`}
                                onChange={this.handleChange}
                                value={this.state.email}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="d-flex gap-20">
                          <div className="w-100 d-flex mt-3 align-items-end justify-content-end">
                            {this.state.isData ? (
                              <button className="btn btn-grd-disabled mr-2">Booking...!</button>
                            ) : (
                              <>
                                <button
                                  onClick={this.onBooking}
                                  className="btn book-btn btn-grd-disabled mr-2"
                                >
                                  <i className="icofont icofont-save"></i>
                                  Book
                                  {/* <Link to={`/add-ons`}> Book</Link> */}
                                </button>
                                <button
                                  onClick={this.clearData}
                                  className="btn clear-btn btn-grd-disabled"
                                >
                                  <i className="icofont icofont-clear"></i> Clear
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ConciergeEventAdd
